import React, { Component } from "react"
import { Link } from "react-router-dom";
import NewFooter from "../footer/newfooter"
import NewHeader from "../header/newheader"
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import togglearrow from '../assets/Home/togglearrow.png'
import downarrow from "../assets/grants/down.png"
import Axios from "axios";
import { BASE } from "../api/api";
import "./grants.css"
import ReactPaginate from 'react-paginate';
import { List } from "react-content-loader";

class Grants extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grants: null,
            limit: 10,
            offset: 0,
            tab1: false,
            tab2: false,
            tab3: false,
            filter: { lead: "", institution: "", year: "" },
            filterFired: false
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        let year = [], i
        for (i = new Date().getFullYear(); i >= 2010; i--) {
            year.push(i)
        }
        this.setState({
            year: year,
        })
        this.getGrants(0, 10, [])
        this.getAuthors()
        Axios.get(`${BASE}jsonapi/node/faculty?include=field_author_faculty`)
            .then(item => {
                this.setState({
                    faculty: item.data.data
                })
            })
            .catch(err => {
                console.log("faculty not found", err)
            })
        Axios.get(`${BASE}jsonapi/taxonomy_term/authority`)
            .then(res => {
                this.setState({
                    authorities: res.data.data
                })
            })
            .catch(err => {
                console.log("error in authority", err)
            })
    }
    getAuthors() {
        Axios.get(`${BASE}jsonapi/node/project?include=field_lead_project__investigator`)
            .then(res => {
                if (res.data.links.next) {
                    Axios.get(`${BASE}jsonapi/node/project?include=field_lead_project__investigator`)
                        .then(resp1 => {
                            let data = resp1.data.included ? res.data.included.concat(resp1.data.included).sort((a, b) => parseFloat(a.attributes.title) - parseFloat(b.attributes.title)) : res.data.included
                            const author = data.map(x => {
                                return x.attributes.title
                            })
                            this.setState({
                                authors: author.filter((item, index) => author.indexOf(item) === index)
                            })
                        })
                }
                else {
                    let data = res.data.included ? res.data.included.sort((a, b) => parseFloat(a.attributes.title) - parseFloat(b.attributes.title)) : []
                    const author = data.map(x => {
                        return x.attributes.title
                    })
                    this.setState({
                        authors: author.filter((item, index) => author.indexOf(item) === index),
                    })
                }
            })
            .catch(err => {
                console.log("error on author get", err)
            })
    }
    getGrants = async (offset, limit, filter) => {
        this.setState({
            grants: null
        })
        let yearstring = filter.year ? `&filter[year-filter][condition][path]=field_project_start_date&filter[year-filter][condition][operator]=CONTAINS&filter[year-filter][condition][value]=${filter.year}-` : ""
            , leadstring = filter.lead ? `&filter[lead-filter][condition][path]=field_lead_project__investigator.title&filter[lead-filter][condition][operator]==&filter[lead-filter][condition][value]=${filter.lead}` : "",
            authoritystring = filter.institution ? `&filter[field_grant.field_authority.name]=${filter.institution}` : ""
        Axios.get(`${BASE}jsonapi/node/project?include=field_lead_project__investigator,field_grant_authoritys,field_grant,field_grant.field_authority${yearstring}${leadstring}${authoritystring}&page[offset]=${offset}&page[limit]=${limit}&sort=-field_project_start_date`, {
            headers: {
                "Authorization": "Basic cGFyYWdyYXBoX3VzZXI6cGFyYWdyYXBoX3VzZXI="
            }
        })
            .then(res => {
                let count = res.data.meta ? res.data.meta.count / this.state.limit : 0
                console.log("grand count", res.data.meta ? res.data.meta.count : "", ":", count)
                this.setState({
                    grants: res.data.data,
                    grantsIncluded: res.data.included,
                    grantCount: Math.ceil(count)
                })
            })
            .catch(err => {
                console.log("error on grants get", err)
            })
    }
    setFilter(data) {
        let filter = this.state.filter
        if (data.name === "year") {
            filter.year = filter.year == data.value ? "" : data.value
            this.setState({
                filter: filter,
                filterFired: !this.state.filterFired,
                offset: 0
            })
        }
        else if (data.name === "lead") {
            filter.lead = filter.lead == data.value ? "" : data.value
            this.setState({
                filter: filter,
                filterFired: !this.state.filterFired,
                offset: 0
            })
        }
        else if (data.name == "authority") {
            filter.institution = filter.institution == data.value ? "" : data.value
            this.setState({
                filter: filter,
                filterFired: !this.state.filterFired,
                offset: 0
            })
        }
    }
    setLimit(e) {
        console.log("page coming", e)
        let offset = e.selected * this.state.limit
        this.setState({
            offset: offset
        }, () => {
            this.getGrants(this.state.offset, this.state.limit, this.state.filter)
            window.scrollTo(0, 0)
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterFired !== this.state.filterFired) {
            this.getGrants(this.state.offset, this.state.limit, this.state.filter)
            window.scrollTo(0, 0)
        }
    }
    render() {
        return (
            <div id="grants page">
                <NewHeader />
                <div >
                    <div className="title-banner">
                        <h1 className="heading-one bold white-text">Grants</h1>
                    </div>
                    <div className="container">
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} /> <Link to='/theses' className='gray-text'>Research</Link> <img className='rightarrow' src={crumbarrow} /><Link to='/theses' className='gray-text'>CIS Student Theses</Link></div>
                            {/* <TopBar data={'data1'} /> */}
                        </div>
                        <p className="text-justify">
                            The Research Division at College of Islamic Studies administers a number of grants
                            for its faculty. The responsibility lies in monitoring the performance of awarded
                            grants on a timely manner, submitting progress reports and ensuring adherence to
                            performance goals, to time schedules and maintaining a record of all documents
                            relevant to the award. The projects and supporting grants are both national as well
                            as international and or a combination of both. Over the years, the CIS staff and
                            students have received numerous such grants and undertaken multiple projects.
                            The list below reflects the wealth of research carried out in CIS by grants awarded to
                            its faculty.
                        </p>
                        <div className="rows grants-datas">
                            <div className='grants-toggle'>
                                <div className='toggle-head subtitle-one bold gray-text'>
                                    Filter
                                </div>
                                <div className="toggle-bar-one">
                                    <button className={this.state.tab1 ? 'blue-text body-two active' : "gray-text body-two"} onClick={() => this.setState({ tab1: !this.state.tab1, offsetcompleted: 0, offsetsuspended: 0 })}>Granting Institutions&nbsp; <img className='down-arrow' src={downarrow} /></button>
                                    <div className="toggle-list" style={{ display: this.state.tab1 ? "" : "none" }}>
                                        {this.state.authorities ? this.state.authorities.map((item) => {
                                            return (
                                                <p className={`body-three ${item.attributes.name === this.state.filter.institution ? "blue-text" : "gray-text"}`} onClick={() => this.setFilter({ name: "authority", value: item.attributes.name })} >
                                                    {item.attributes.name}
                                                </p>
                                            )
                                        }) : ""}
                                    </div>
                                    <button className={this.state.tab2 ? 'blue-text body-two active' : "gray-text body-two"} onClick={() => this.setState({ tab2: !this.state.tab2, offsetongoing: 0, offsetsuspended: 0 })}>Project Lead&nbsp;<img className='down-arrow' src={downarrow} /></button>
                                    <div className="toggle-list" style={{ display: this.state.tab2 ? "" : "none" }}>
                                        {this.state.authors ? this.state.authors.map((item) => {
                                            return (
                                                <p className={`body-three ${item === this.state.filter.lead ? "blue-text" : "gray-text"}`} onClick={() => this.setFilter({ name: "lead", value: item })}>{item}</p>
                                            )
                                        }) : <List />}
                                    </div>
                                    <button className={this.state.tab3 ? 'blue-text body-two active' : "gray-text body-two"} onClick={() => this.setState({ tab3: !this.state.tab3, offsetcompleted: 0, offsetongoing: 0 })}>Year&nbsp;<img className='down-arrow' src={downarrow} /></button>
                                    <div className="toggle-list" style={{ display: this.state.tab3 ? "" : "none" }}>
                                        {this.state.year ? this.state.year.map((year) => {
                                            return (
                                                <p className={`body-three ${year === this.state.filter.year ? "blue-text" : "gray-text"}`} onClick={() => this.setFilter({ name: "year", value: year })}>{year}</p>
                                            )
                                        }) : ""}
                                    </div>
                                </div>
                            </div>
                            <div className='table-container w-100'>
                                <table className='newTable'>

                                    <tr className='projectStatus-head'>
                                        <th className='title'><p>Project Name</p></th>
                                        <th className='institution min-wids'><p> Granting Institution</p></th>
                                        <th className='lead min-wids'><p>Project Lead</p></th>
                                        <th className='year min-wids'><p> Year</p></th>
                                    </tr>
                                    {
                                        this.state.grants ? this.state.grants.length ? this.state.grants.map((item) => {
                                            let year = item.attributes.field_project_start_date ? new Date(item.attributes.field_project_start_date).getFullYear() : "",
                                                lead, faculty,
                                                grant = item.relationships.field_grant.data.length ? item.relationships.field_grant.data : []
                                            if (item.relationships.field_lead_project__investigator.data) {
                                                lead = this.state.grantsIncluded.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                    let id = x.relationships.field_author_faculty.data.filter(y => {
                                                        if (y.id == item.relationships.field_lead_project__investigator.data.id)
                                                            return y.id
                                                    })
                                                    if (id.length)
                                                        return id[0].id
                                                }) : ""
                                            }
                                            return <tr>
                                                <td className="title">
                                                    <Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link>
                                                </td>
                                                <td style={{ textAlign: "center", minWidth: "240px" }}>{grant.length ? grant.map((grants) => {
                                                    let authorityid = this.state.grantsIncluded.filter(x => x.id === grants.id).length ? this.state.grantsIncluded.filter(x => x.id === grants.id)[0].relationships.field_authority.data ? this.state.grantsIncluded.filter(x => x.id === grants.id)[0].relationships.field_authority.data.id : "" : ''

                                                    return (
                                                        <p className="text-center">{authorityid ? this.state.grantsIncluded.filter(x => x.id == authorityid)[0].attributes.name : ""}</p>
                                                    )
                                                }) : ""}</td>
                                                <td className="lead min-wids text-center">
                                                    {item.relationships.field_lead_project__investigator.data ? faculty.length ? <Link to={`/faculty/${faculty[0].attributes.title}?nid=${faculty[0].attributes.drupal_internal__nid}`}> {lead[0].attributes.title ? lead[0].attributes.title : ""}</Link> : lead.length ? lead[0].attributes ? <p className="text-center"> {lead[0].attributes.title ? lead[0].attributes.title : ""}</p> : '' : "" : ""}
                                                </td>
                                                <td className="year text-center min-wids">{year}</td>
                                            </tr>
                                        })
                                            : "" : <List />
                                    }
                                    <tr>

                                    </tr>
                                    {this.state.grantCount === 0 ? <p>No Grants found</p> : ""}
                                </table>
                                {this.state.grants ? this.state.grants.length ? <div className="numbered-pagination"> <ReactPaginate
                                    nextLabel="Next"
                                    onPageChange={(e) => this.setLimit(e)}
                                    onClick={(e) => this.setLimit(e)}
                                    pageRangeDisplayed={2}
                                    marginPagesDisplayed={2}
                                    pageCount={this.state.grantCount}
                                    previousLabel="Prev"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="previous-item"
                                    previousLinkClassName="previous-link"
                                    nextClassName="next-item"
                                    nextLinkClassName="next-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    activeLinkClassName="activePage"
                                    forcePage={Math.ceil((this.state.offset / 10))}
                                    renderOnZeroPageCount={null}
                                />
                                </div> : "" : ""}
                            </div>
                        </div>

                    </div>
                </div>
                <NewFooter />
            </div>
        )
    }
}
export default Grants;